/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PriceStatus = {
    Preliminary: 'Preliminary',
    Approved: 'Approved'
} as const;
export type PriceStatus = typeof PriceStatus[keyof typeof PriceStatus];


export function instanceOfPriceStatus(value: any): boolean {
    for (const key in PriceStatus) {
        if (Object.prototype.hasOwnProperty.call(PriceStatus, key)) {
            if (PriceStatus[key as keyof typeof PriceStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PriceStatusFromJSON(json: any): PriceStatus {
    return PriceStatusFromJSONTyped(json, false);
}

export function PriceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceStatus {
    return json as PriceStatus;
}

export function PriceStatusToJSON(value?: PriceStatus | null): any {
    return value as any;
}

export function PriceStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PriceStatus {
    return value as PriceStatus;
}

